import { RiCalendarLine } from "@itandi/itandi-bb-ui";
import type { ReactNode } from "react";
import React from "react";
import { Button } from "~/components/common/parts/button/Button";
import {
	TYPE_CLEANING,
	TYPE_MISC_CONSTRUCTION,
	TYPE_RECOVERING_CONSTRUCTION
} from "~/constants/DealConstructionConst";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import type { NskResponse } from "~/models/Api";
import type { Deal } from "~/models/Deal";
import type {
	ConstructionScheduleType,
	DealConstructionScheduleEdit
} from "~/models/DealConstructionSchedule";
import { CONSTRUCTION_SCHEDULE_LABELS } from "~/models/DealConstructionSchedule";
import { formatDate } from "~/utils/DateUtil";
import { ScheduleInputModal } from "./ScheduleInputModal";
import Styles from "./ScheduleInputNavigation.module.scss";

const constructionNumbers: ConstructionScheduleType[] = [
	TYPE_MISC_CONSTRUCTION,
	TYPE_RECOVERING_CONSTRUCTION,
	TYPE_CLEANING
];

type Props = {
	deal: Deal;
	handleMutate: () => Promise<void>;
	handleSubmit: (
		schedules: DealConstructionScheduleEdit[]
	) => Promise<NskResponse>;
};

export const ScheduleInputNavigation: React.FC<Props> = ({
	deal,
	handleSubmit,
	handleMutate
}: Props) => {
	const { isOpen, handleOpen, handleClose } = useOpenHandler();
	return (
		<div className={Styles.NavigationBlock}>
			<div className={Styles.IconWrapper}>
				<RiCalendarLine className={Styles.Icon} />
			</div>
			<div className={Styles.NavigationContent}>
				<div>
					<h4 className={Styles.Title}>工事日程を入力してください</h4>
					<div className={Styles.Schedules}>
						{constructionNumbers.map(
							(typeNumber: ConstructionScheduleType): ReactNode => {
								const schedule = deal.dealConstructionSchedules.find(
									(s) => s.constructionScheduleType === typeNumber
								);
								if (schedule == null) {
									return <React.Fragment key={typeNumber} />;
								}
								return (
									<div className={Styles.ScheduleRow} key={typeNumber}>
										{CONSTRUCTION_SCHEDULE_LABELS[typeNumber]}:
										{formatDate(schedule.startDate)} -
										{formatDate(schedule.endDate)}
									</div>
								);
							}
						)}
					</div>
				</div>
				<div className={Styles.DetailLinkBlock}>
					<Button
						className={Styles.DetailLinkButton}
						onClick={handleOpen}
						variant="normal"
					>
						工事日程を入力
					</Button>
					<ScheduleInputModal
						deal={deal}
						handleClose={handleClose}
						handleMutate={handleMutate}
						handleSubmit={handleSubmit}
						isOpen={isOpen}
					/>
				</div>
			</div>
		</div>
	);
};
